<!-- <ng-container *ngIf="!(isLoading$ | async); else loading"> -->
@if (viewMode === ViewModes.Grid) {
  <div infiniteScroll [infiniteScrollDistance]="5" [infiniteScrollThrottle]="12"
    [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty"
    (scrolled)="scrollPage(model?.pagination?.currentPage + 1)">
    <div class="row m-0 pr-2 pl-2">
      @for (product of model?.products; track product) {
        <app-custom-product-grid-item [product]="product"
        class="col-6 col-sm-5 col-md-3"></app-custom-product-grid-item>
      }
    </div>
    <div class="mt-5">
      @if (
        (isMaxProducts || isLastPage) && model?.pagination?.currentPage > 0
        ) {
        <span (click)="scrollToTop()" class="back-to-top"><app-custom-icons
        [type]="iconType.ARROW_GO_BACK"></app-custom-icons>
      </span>
    }
    <div class="d-flex justify-content-center">@if (isMaxProducts && !isLastPage) {
      <button
        (click)="loadNextPage(model?.pagination?.currentPage + 1)" class="btn btn-white">
        {{ 'productList.showMoreBtn' | cxTranslate }}
      </button>
    }</div>
  </div>
  @if (appendProducts) {
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  }
</div>
@if (searchResults$ | async; as searchResults) {
  <div class="bottom-long-description" [innerHTML]="searchResults?.categoryBottomLongDescription"></div>
}
}

@if (viewMode === ViewModes.List) {
  <div infiniteScroll [infiniteScrollDistance]="3" [infiniteScrollThrottle]="50"
    [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty"
    (scrolled)="scrollPage(model?.pagination?.currentPage + 1)">
    @for (product of model?.products; track product) {
      <cx-product-list-item [product]="product"
      class="cx-product-search-list"></cx-product-list-item>
    }
    <div [className]="
        !isLastPage && model?.pagination?.currentPage > 0
          ? 'cx-double-btn-container'
          : 'cx-single-btn-container'
      ">
      @if (
        (isMaxProducts || isLastPage) && model?.pagination?.currentPage > 0
        ) {
        <div (click)="scrollToTop()" class="btn btn-block btn-action">
          {{ 'productList.backToTopBtn' | cxTranslate }}
        </div>
      }
      @if (isMaxProducts && !isLastPage) {
        <div (click)="loadNextPage(model?.pagination?.currentPage + 1)"
          class="btn btn-block btn-action align-btn">
          {{ 'productList.showMoreBtn' | cxTranslate }}
        </div>
      }
    </div>
    @if (appendProducts) {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  </div>
}
<!-- </ng-container> -->

<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
